import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/reports";

// params: { from, to (YYYY-MM-DD), limit, sort }
const orders = (params = {}) =>
  axios.get(`${API_URL}/orders`, { params, headers: authHeader() });

const customers = (params = {}) =>
  axios.get(`${API_URL}/customers`, { params, headers: authHeader() });

const products = (params = {}) =>
  axios.get(`${API_URL}/products`, { params, headers: authHeader() });

const ReportService = { orders, customers, products };

export default ReportService;
